var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.8,
    cy: 24.8,
    r: 24.8,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#636363",
    fillRule: "nonzero",
    d: "m31.36 11.68-3.92-.16a5.76 5.76 0 0 0-5.76 5.68v3.68h-3.6a.24.24 0 0 0-.24.24v4.64c.04.112.128.2.24.24h3.6v11.6c0 .16.16.24.32.24h4.72a.24.24 0 0 0 .24-.24V26h3.6c.16 0 .24-.08.32-.24l.56-4.56a.324.324 0 0 0-.08-.24h-4.4v-2.32a2.8 2.8 0 0 1 .48-1.76 1.438 1.438 0 0 1 1.12-.48h2.72c.16 0 .32-.08.32-.24V12a.24.24 0 0 0-.24-.32z"
  }))));
};
export default SvgFacebook;